import { apiGet, apiPatch, apiPost } from "../../../utils";

export function getAllOperationsAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const url = `/api/operation/${params.organizationId}?${searchParams.toString()}`;
  return apiGet(url);
}

export function getAllTeamOperationsAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const url = `/api/operation/get-operations-for-team/${params.organizationId}?${searchParams.toString()}`;
  return apiGet(url);
}

export const getOperationByIdAPI = (params) => {
  const { id = '' } = params || {};
  return apiGet(`/api/operation/get-operation-contract-by-id/${id}`);
};

export const calculateOperationAPI = (params, payload) => {
  const { id = '' } = params || {};
  return apiPost(`/api/operation/calculate-oprtation/${id}`, payload);
};

export const getOrganizationDetailsAPI = (params) => {
  const { id = '' } = params || {};
  return apiGet(`/api/organizations/get-organization-by-id/${id}`);
};

export const getInvoiceByIdAPI = (params) => {
  const { id = '' } = params || {};
  return apiGet(`/api/invoice/getInvoiceById/${id}`);
};

export const createInvoiceAPI = (payload) => {
  return apiPost(`/api/invoice/createInvoice`, payload);
};

export const editInvoiceAPI = (payload) => {
  const { finalPdfData, separated, id, contractType } = payload || {};
  return apiPatch(`/api/invoice/updateInvoice/${id}`, { finalPdfData, separated, contractType });
};

export const postInvoiceAPI = (payload) => {
  const { id, separated, contractType } = payload || {};
  return apiPatch(`/api/invoice/postInvoice/${id}`, { separated, contractType });
};

export const getInvoiceDetailsAPI = () => {
  return apiGet(`/api/invoice/getInvoiceDetails`);
};

export const queryByPDFdownloadAPI = (queryid, isLaytime) => {
  return apiGet(`/api/operation/get-electric-pdf/${queryid}/?isLaytime=${isLaytime}`);
};

export const createOperationAPI = (payload) => {
  return apiPost(`/api/operation/create-operation`, payload);
};

export const createNextTripAPI = (payload) => {
  return apiPost(`/api/operation/create-next-trip`, payload);
};

export const endTripAPI = (payload) => {
  return apiPost(`/api/operation/end-trip`, payload);
};

export const checkTripEligibilityAPI = (operationId) => {
  return apiGet(`/api/operation/check-trip-eligibility/${operationId}`);
};

export function getVoyageListAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, String(value));
    }
  });

  const url = `/api/contract/get-voyage-list/${params.organizationId}?${searchParams.toString()}`;
  return apiGet(url);
}

export function getCargoVoyageListAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, String(value));
    }
  });

  const url = `/api/contract/get-cargo-voyage-list/${params.organizationId}?${searchParams.toString()}`;
  return apiGet(url);
}